export var namespace = function namespace(_namespace, block) {
  var target = window;

  _namespace.split('.').forEach(function (name) {
    target = target[name] || (target[name] = {});
  });

  return block(target, _namespace);
};